<template>
  <div class="app-container" id="app" :style="appPaddingStyle">
    <router-view />
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
      userIp: (state) => state.user.userIp,
    }),
    appPaddingStyle() {
      if (this.userPlatform === 0) {
        return {
          paddingBottom: "2rem",
        };
      }
      return {};
    },
  },
  created(){
    const defaultIP = '117.122.241.235'
    if(!this.userIp){
      this.setUserIP(defaultIP)
    }
  },
  methods:{
     ...mapMutations({
      setUserIP:"user/setUserIP",
    })
  }

};
</script>


<style lang="scss" >
.app-container {
  min-height: 100vh;
  font-size: 16px;

  .img-icon {
    width: 0.5rem;
    object-fit: contain;
  }
  .card-head-line {
    width: 100%;
    height: 6px;
    background: linear-gradient(to right, #58627f, #e8e7ec);
  }
  .bi-title {
    
    padding-bottom: 13px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .bi-alink {
    color: #2d8cf0;
    cursor: pointer;
  }
}

.main-container {
  width: 100%;
}
* {
  box-sizing: border-box;
}

// 引入思源黑体

/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
// @font-face {
//   font-family: "思源黑体 Regular";font-weight: 400;src: url("//at.alicdn.com/wf/webfont/2Os2MvFAvDEt/0EWJstqDx8an6-G6b_KvE.woff2") format("woff2"),
//   url("//at.alicdn.com/wf/webfont/2Os2MvFAvDEt/L1fi4hv9xjurLbGnbkorh.woff") format("woff");
//   font-display: swap;
// }
/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "SIYUSIYUAN Normal";font-weight: 350;src: url("//at.alicdn.com/wf/webfont/2Os2MvFAvDEt/yIuVAh1Xe1DNGSedLwP1K.woff2") format("woff2"),
  url("//at.alicdn.com/wf/webfont/2Os2MvFAvDEt/EsFu5XttZEYhQkJ0mPCgn.woff") format("woff");
  font-display: swap;
}
* {
  font-family: "SIYUSIYUAN Normal", Helvetica, "Microsoft YaHei", Arial, sans-serif;
}

/** 字体颜色 */
.color-t333{
  color: #333333;
}
@media (min-width: 1280px) {
  .main-container {
    width: 1200px;
    margin: auto;
    overflow: hidden;
  }
}
</style>
